
import algoliasearch from 'algoliasearch'
import { apiKey, appId, indexName }  from '../config'

const client = algoliasearch(appId, apiKey);

export const indexSearch = (query, lang, page, hitsPerPage, filters) => {
  const index = client.initIndex(indexName + '__' + lang);
  const indexQuery = {
    page: page,
    hitsPerPage: hitsPerPage,
  };
  if (undefined !== query) {
    indexQuery.query = query;
  }
  if (undefined !== filters) {
    indexQuery.filters = filters;
  }

  return index.search('', indexQuery)
    .then( response => {

      return response;
    })
    .catch( error => {
      console.log("Oups, something wrong happened when agolia searched")
      console.log(error)
    })
}
